var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"my-5 font-size-12 text-uppercase text-muted text-center"})
}
var staticRenderFns = []

export { render, staticRenderFns }